import styled from 'styled-components';

import hair from '../../assets/hair.svg';
import media from '../../styles/media.style';
import { BG_GRAY, PAGE_WIDTH } from '../../styles/variables.style';

export const Section = styled.div`
  align-items: center;
  background: center / cover no-repeat url(${hair}), ${BG_GRAY.COMMON_1};
  display: flex;
  flex-direction: column;
  padding: 50px 0;

  ${media.tabletL`
    padding: 90px 0;
  `};
`;

export const Title = styled.div`
  margin-bottom: 25px;
  position: relative;
  text-transform: uppercase;

  &::after {
    background-color: #333;
    bottom: -25px;
    content: '';
    height: 2px;
    left: calc(50% - 20px);
    position: absolute;
    width: 40px;
  }
`;

export const TreatmentsWrapper = styled.div`
  max-width: ${PAGE_WIDTH}px;
  overflow-x: scroll;
  padding-bottom: 15px;
  width: 100%;

  ${media.tabletL`
    overflow-x: hidden;
    padding: 0 100px;
  `};

  ${media.desktop`
    padding: 0 190px;
  `};
`;

export const Treatments = styled.div`
  display: flex;
  margin-top: 35px;
  padding-left: 20px;
  width: max-content;

  ${media.tabletL`
    flex-direction: column;
    padding-left: 0;
    width: 100%;
  `};
`;

export const Treatment = styled.div`
  align-items: stretch;
  background-color: white;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  padding: 20px;
  width: calc(100vw - 60px);

  ${media.tabletL`
    flex-direction: row;
    margin-left: 0;
    margin-top: 20px;
    padding: 50px 110px 50px 50px;
    width: 100%;
  `};

  &:first-child {
    margin-left: 0;
    margin-top: 0;
  }
`;

export const TreatmentImage = styled.div`
  width: 100%;

  ${media.tabletL`
    width: 40%;
  `};
`;

export const TreatmentDetails = styled.div`
  width: 100%;

  ${media.tabletL`
    display:flex;
    flex-direction: column;
    margin-left: 50px;
  `};
`;

export const TreatmentName = styled.div`
  font-family: FuturaStd;
  font-size: 15px;
  line-height: 1.27;
  margin-top: 20px;
  text-transform: uppercase;

  ${media.tabletL`
    font-size: 18px;
    font-weight: 500;
    margin-top: 0;
  `};
`;

export const TreatmentDescription = styled.div`
  font-family: FuturaStd;
  font-size: 15px;
  line-height: 1.33;
  margin-top: 15px;

  ${media.tabletL`
    flex-grow: 1;
  `};
`;

export const TreatmentFootnote = styled.div`
  ${media.tabletL`
    display: flex;
    justify-content: space-between;
  `};
`;

export const TreatmentDuration = styled.div`
  font-family: FuturaStd;
  font-size: 15px;
  margin-top: 15px;
`;

export const TreatmentLink = styled.div`
  cursor: pointer;
  font-family: FuturaStd;
  font-size: 11px;
  font-weight: bold;
  text-decoration: underline;
  text-transform: uppercase;
  margin-top: 15px;
`;



// WEBPACK FOOTER //
// ./src/pages/TreatmentPage/ReleatedTreatments.style.js